import Content from "./Content";

export default function AdminRequestPage() {
  return <Content />
} 